import MyTabs from '../../components/MyTabs';
import Section1 from './PostDetailsForm';

const GeneralPosts = () => {

    const tabs = [
        { id: "section1", title: "Post Info", Component: Section1  },
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default GeneralPosts;